import { render, staticRenderFns } from "./ServicesGrid.vue?vue&type=template&id=fc618c80"
import script from "./ServicesGrid.vue?vue&type=script&lang=js"
export * from "./ServicesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports